import React, { useState } from 'react';
import '../Editor.css'; // Import the new shared editor styles

const DialogueEditor = ({ selectedNpc, dialogues, setEditingDialogue, setCurrentDialogue }) => {
  const [expandedDialogues, setExpandedDialogues] = useState({});

  const toggleDialogueExpand = (dialogueIndex) => {
    setExpandedDialogues(prev => ({
      ...prev,
      [dialogueIndex]: !prev[dialogueIndex]
    }));
  };

  return (
    <div className="editor-container dialogue-editor-container">
      <h3>Dialogue Editor</h3>
      {selectedNpc ? (
        dialogues[selectedNpc] && dialogues[selectedNpc].length > 0 ? (
          <ul className="editor-list">
            {dialogues[selectedNpc].map((dialogue, index) => {
              if (!dialogue) return null; // Skip empty dialogues
              
              const isExpanded = expandedDialogues[index];
              
              return (
                <li key={index} className="editor-list-item">
                  <div className="editor-list-item-content">
                    <div 
                      className={`editor-text ${isExpanded ? 'full' : ''}`}
                      title={isExpanded ? '' : dialogue}
                      onClick={() => toggleDialogueExpand(index)}
                    >
                      <span className="dialogue-index">{index}:</span> {dialogue}
                    </div>
                    <div className="editor-actions">
                      <button 
                        className="editor-button edit"
                        onClick={() => {
                          setEditingDialogue({ npc: selectedNpc, index: index });
                          setCurrentDialogue(dialogue);
                        }}
                      >
                        Edit
                      </button>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
          <div className="empty-state">No dialogues found for this NPC. Add some dialogues using the input field above.</div>
        )
      ) : (
        <div className="empty-state">Select an NPC to view and edit dialogues.</div>
      )}
    </div>
  );
};

export default DialogueEditor;
